var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoCamera = function SvgIconVideoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 15.375v-8.75h11.75a2 2 0 0 1 2 2v8.75H4.5a2 2 0 0 1-2-2m15.75-.152v2.402a1.75 1.75 0 0 1-1.75 1.75h-12a4 4 0 0 1-4-4v-9a1.75 1.75 0 0 1 1.75-1.75h12a4 4 0 0 1 4 4v.152l3.754-2.145A1 1 0 0 1 23.5 7.5v9a1 1 0 0 1-1.496.868zm0-2.303 3.25 1.857V9.223l-3.25 1.857z",
    clipRule: "evenodd"
  })));
};
export default SvgIconVideoCamera;